export default "__VITE_ASSET__CdsYY5EV__"